import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./CSS/Fans.css";
import Store from "../Store/Store";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

import {
  SET_FETCH_TAG_VALUE_CONTROL,
  set_booster_tags,
  set_fans_tags,
  set_pumps_tags,
  set_tag_values,
  set_external_trend_info,
} from "../Action/Action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

let state_2 = [
  {
    "WC FAN ": [
      { text: "WC Çalışma Durumu", tagId: "161" },
      { text: "WC Arıza Durumu", tagId: "162" },
      { text: "Faz 1 Voltaj", tagId: "150" },
      { text: "Faz 1 Akım", tagId: "153" },
      { text: "Faz 2 Voltaj", tagId: "151" },
      { text: "Faz 2 Akım", tagId: "154" },
      { text: "Faz 3 Voltaj", tagId: "152" },
      { text: "Faz 3 Akım", tagId: "155" },
      { text: "WC Fanı Toplam Enerji Sarfiyatı", tagId: "156" },
    ],
  },
  {
    "DAVLUMBAZ FAN": [
      { text: "Davlumbaz Çalışma Durumu", tagId: "159" },
      { text: "Davlumbaz Arıza Durumu", tagId: "160" },
      { text: "Faz 1 Voltaj", tagId: "143" },
      { text: "Faz 1 Akım", tagId: "146" },
      { text: "Faz 2 Voltaj", tagId: "144" },
      { text: "Faz 2 Akım", tagId: "147" },
      { text: "Faz 3 Voltaj", tagId: "145" },
      { text: "Faz 3 Akım", tagId: "148" },
      { text: "Davlumbaz Fanı Toplam Enerji Sarfiyatı", tagId: "149" },
    ],
  },
];
const inital_func = () => {
  var obj__ = [];
  var obj2__ = [];

  state_2.forEach((item) => {
    Object.entries(item).forEach((a) => {
      obj__.push(a[1]);
    });
  });

  obj__.forEach((item2) => {
    item2.forEach((item3) => {
      obj2__.push({ tagId: item3.tagId });
    });
  });

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/fans") {
        try {
          const request = await fetch(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            {
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
              },
              method: "POST",
              body: JSON.stringify(obj2__),
            }
          );
          const response = await request.json();



          Store.dispatch(set_fans_tags(response));
        } catch (err) {
          console.log(err);
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 5000);
};

setTimeout(() => {
  inital_func();
}, 3000);

const Fans = (props) => {
  const [tag_values, Set_tag_values] = useState([]);

  const [state, SetState] = useState(state_2);
  const history = useHistory();
  const maxValueByType = {
    TÜKETİM: 15000,
    GÜÇ: 10000,
    "L1 GERİLİM": 240,
    "L2 GERİLİM": 240,
    "L3 GERİLİM": 240,
    "L1 AKIM": 250,
    "L2 AKIM": 250,
    "L3 AKIM": 250,
    "GÜÇ FAKTÖRÜ": 1,
    "REAKTIF GÜÇ": 1000,
    FREKANS: 100,
  };
  const minValueByType = {
    "L1 GERİLİM": 210,
    "L2 GERİLİM": 210,
    "L3 GERİLİM": 210,
  };

  useEffect(() => {

    const roundedResponse = props.fans_tags.map((item) => {
      // props.tag_list'ten item.tagId ile eşleşen elemanı bul
      const matchingTag = props.tag_list.find(tag => tag.tagId === item.tagId);

      // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
      const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null
        ? Number(matchingTag.tagDecimal)
        : 2;

      return {
        ...item,
        tagValue: parseFloat(item.tagValue).toFixed(decimalPlaces),
      };
    });

    if (JSON.stringify(roundedResponse) !== JSON.stringify(props.fans_tags)) {

      Store.dispatch(set_fans_tags(roundedResponse))
    }

  }, [props.fans_tags]);

  useEffect(() => {
    const componentDidMount = () => {
      var obj__ = [];
      var obj2__ = [];

      state_2.forEach((item) => {
        Object.entries(item).forEach((a) => {
          obj__.push(a[1]);
        });
      });

      obj__.forEach((item2) => {
        item2.forEach((item3) => {
          obj2__.push({ tagId: item3.tagId });
        });
      });

      var newdata = [];

      obj2__.forEach((item2) => {
        props.tag_values.forEach((item) => {
          if (item.tagId === item2.tagId) {
            newdata.push({
              tagId: item.tagId,
              tagValue: item.tag_value,
            });
          }
        });
      });

      console.log(newdata);
      //

      Set_tag_values(newdata);
    };

    componentDidMount();
  }, []);

  const getBackgroundStyle = (type, valueString) => {
    const numericValue = parseFloat(valueString);
    const maxValue = maxValueByType[type] || 1;
    const minValue = minValueByType[type] || 0;
    const adjustedValue = Math.max(numericValue - minValue, 0);
    const adjustedMaxValue = maxValue - minValue;
    const ratio = Math.min(Math.max(adjustedValue / adjustedMaxValue, 0), 1);
    if (type.includes("Çalışma Durumu")) {
      return {
        background: `linear-gradient(to right, rgb(76, 187, 23) ${ratio * 100
          }%, white ${ratio * 100}%)`,
      };
    } else if (type.includes("Arıza Durumu") || type.includes("Alarm")) {
      return {
        background: `linear-gradient(to right, 	rgb(255, 49, 49) ${ratio * 100
          }%, white ${ratio * 100}%)`,
      };
    }
    return {
      background: `linear-gradient(to right, rgb(237, 188, 69) ${ratio * 100
        }%, white ${ratio * 100}%)`,
    };
  };

  // setInterval(() => {

  //     console.log(control);

  //     if (props.tag_ids && control === true && window.location.pathname === "/energy") {
  //         const fetch_tag_values = async () => {
  //             try {
  //                 const request = await fetch(
  //                     "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
  //                     {
  //                         headers: {
  //                             "Content-Type": "application/json",
  //                             accept: "application/json",
  //                         },
  //                         method: "POST",
  //                         body: JSON.stringify(obj2__),
  //                     }
  //                 );
  //                 const response = await request.json();

  //                 console.log(response);

  //                 Set_tag_values(response);
  //             } catch (err) {
  //                 console.log(err);
  //             } finally {
  //                 Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false))
  //             }
  //         }

  //         fetch_tag_values()
  //     }

  // }, 10000)

  const loadingStyle = {
    background: "linear-gradient(to right, #f0f0f0 50%, white 50%)",
  };

  const [dis_hava_nem, Set_dis_hava_nem] = useState(null);
  const [dis_hava_sic, Set_dis_hava_sic] = useState(null);

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const componentDidMount = async () => {
      var fetch_obj = [
        {
          tagId: "157",
        },
        {
          tagId: "158",
        },
      ];

      const req = await fetch(
        "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },
          method: "POST",
          body: JSON.stringify(fetch_obj),
        }
      );
      const response = await req.json();

      if (req.status === 200) {
        var newdata = response;
        newdata.forEach((item, index) => {
          if (index === 0) {
            var değer = item.tagValue;
            değer = değer.replaceAll(",", ".");
            değer = Number(değer).toFixed(2);
            değer = String(değer) + " °C";
            Set_dis_hava_sic(değer);
          } else {
            var değer = item.tagValue;
            değer = değer.replaceAll(",", ".");
            değer = Number(değer).toFixed(2);
            değer = String(değer) + " g/m3";
            Set_dis_hava_nem(değer);
          }
        });
      }
    };
    componentDidMount();
  }, [props.fans_tags]);

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);
      //

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  return (
    <>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>

      <section className="section_fans">
        <Link to="/">
          <Button
            style={{
              position: "absolute",
              color: "black",
              top: "12%",
              left: "18%",
              zIndex: 9999999,
              borderRadius: "15px",
              backgroundColor: "#fff",
              border: "3px solid rgba(238, 200, 108, 0.99)",
              fontWeight: 600,
            }}
            className=" movebuttons"
            variant="contained"
          >
            Geri
          </Button>
        </Link>
        <div className="fantop">
          <div>FANLAR</div>
        </div>

        <div className="bottom_fans">
          {state.map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              title.push(a[0]);
              obj_.push(a[1]);
            });

            console.log(obj_);
            // var değer = tag_values
            //     .filter(
            //         (x) => String(x.tagId) === String(item.elementDetails.tagId)
            //     )
            //     .map((a) => a.tagValue);
            return (
              <div className="rows">
                <div className="left">
                  <div></div>
                  <div className="lefttitle">{title[0]}</div>
                </div>
                <div className="right">
                  <div className="right_top">
                    {obj_[0].map((x, index) => {
                      const lastSpaceIndex = x.text.lastIndexOf(" ");
                      const lastWord = x.text.substring(lastSpaceIndex + 1);
                      return (
                        <div className={x.class + " righttop"}>
                          {lastWord === "Akım"
                            ? x.text + " (A)"
                            : lastWord === "Voltaj"
                              ? x.text + " (V)"
                              : lastWord === "Sarfiyatı"
                                ? x.text + " (kWh)"
                                : x.text}
                        </div>
                      );
                    })}
                  </div>
                  <div className="right_bottom">
                    {obj_[0].map((x, index) => {
                      console.log(x, props.fans_tags);
                      var değerler = props.fans_tags
                        .filter((a) => String(a.tagId) === String(x.tagId))
                        .map((b) => b.tagValue);




                      var değerler_eleman = değerler[0];




                      // function sondanIlkBoslukIndexiniBul(metin) {
                      //   // Metni ters çevir
                      //   var tersMetin = metin.split('').reverse().join('');

                      //   // İlk boşluğun index'ini bul
                      //   var ilkBoslukIndex = tersMetin.indexOf(' ');

                      //   // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                      //   var orijinalIndex = metin.length - 1 - ilkBoslukIndex;

                      //   return orijinalIndex;
                      // }

                      // function metniIndexeKadarAl(metin, index) {
                      //   // substring kullanarak
                      //   var metinSubstring = metin.substring(0, index);

                      //   // veya slice kullanarak

                      //   metinSubstring = String(metinSubstring);
                      //   metinSubstring = metinSubstring.replaceAll(",", ".");

                      //   metinSubstring = Number(metinSubstring).toFixed(2)

                      //   return metinSubstring
                      // }

                      // function sondanIlkBosluktanSonrakiKisim(metin) {
                      //   // Metni ters çevir
                      //   var tersMetin = metin.split('').reverse().join('');

                      //   // İlk boşluğun index'ini bul
                      //   var ilkBoslukIndex = tersMetin.indexOf(' ');

                      //   // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                      //   var orijinalIndex = metin.length - 1 - ilkBoslukIndex;

                      //   // İlk boşluğun index'inden sonraki kısmı al
                      //   var sonrakiKisim = metin.substring(orijinalIndex + 1);

                      //   return sonrakiKisim;
                      // }
                      var last_değer = String(değerler_eleman);
                      last_değer = last_değer.replaceAll(",", ".");

                      const matchingTag = props.tag_list.find(tag => tag.tagId === x.tagId);

                      // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
                      const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null
                        ? Number(matchingTag.tagDecimal)
                        : 2;

                      

                      last_değer = decimalPlaces!==0?Number(last_değer).toFixed(decimalPlaces):Number(last_değer).toFixed(2)

                      if (x.text.includes("Çalışma Durumu")) {
                        console.log(last_değer, typeof last_değer);

                        if (String(last_değer) === "1.00") {
                          console.log(last_değer, "qwer");
                          last_değer = "ON";
                        } else {
                          last_değer = "OFF";
                        }
                      } else if (
                        x.text.includes("Arıza Durumu") ||
                        x.text.includes("Alarm")
                      ) {
                        if (String(last_değer) === "1.00") {
                          last_değer = "ALARM";
                        } else {
                          last_değer = "NORMAL";
                        }
                      }

                      return değerler.length > 0 ? (
                        değerler.map((değer) => (
                          <div
                            onContextMenu={(e) => {
                              e.preventDefault();
                              const { clientX, clientY } = e;
                              var tagName = props.tag_list
                                .filter((b) => b.tagId === x.tagId)
                                .map((c) => c.tagName)[0];

                              console.log(clientX, clientY);
                              document
                                .querySelector(".show_external_trend")
                                .classList.toggle("show_external_trend_active");
                              document.querySelector(".show_tagId").innerHTML =
                                x.tagId;
                              document.querySelector(
                                ".show_tagName"
                              ).innerHTML = tagName;

                              var popup = document.querySelector(
                                ".show_external_trend"
                              );
                              const popupRect = popup.getBoundingClientRect();
                              const viewportWidth = window.innerWidth;
                              const viewportHeight = window.innerHeight;

                              // Calculate the new positions
                              let newX = clientX;
                              let newY = clientY;

                              // Adjust if the popup would overflow the right edge of the viewport
                              if (newX + popupRect.width > viewportWidth) {
                                newX = viewportWidth - popupRect.width;
                              }

                              // Adjust if the popup would overflow the bottom edge of the viewport
                              if (newY + popupRect.height > viewportHeight) {
                                newY = viewportHeight - popupRect.height;
                              }

                              // Adjust if the popup would overflow the left edge of the viewport
                              if (newX < 0) {
                                newX = 0;
                              }

                              // Adjust if the popup would overflow the top edge of the viewport
                              if (newY < 0) {
                                newY = 0;
                              }

                              // Set the position of the popup
                              popup.style.left = `${newX}px`;
                              popup.style.top = `${newY}px`;
                            }}
                            style={getBackgroundStyle(x.text, değer)}
                          >
                            {last_değer}
                          </div>
                        ))
                      ) : (
                        <div style={loadingStyle}>{"Veri Yükleniyor"}</div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    pages_: state.project_reducer.pages,
    tag_ids: state.project_reducer.tag_ids,
    tag_values: state.project_reducer.tag_values,
    user_id: state.auth_reducer.user_id,
    company_id: state.project_reducer.company_id,
    tag_list: state.project_reducer.tag_list,
    white_space_: state.project_reducer.white_space_items,
    fetch_tag_value_control: state.project_reducer.fetch_tag_value_control,
    fans_tags: state.project_reducer.fans_tags,
    tag_list: state.project_reducer.tag_list
  };
};
export default connect(MapStateToProps)(Fans);
